const H = {
  name: "Gibraltar",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 4V2H5V10H7V20H2V22H22V20H17V10H19V2H17V4H15V2H13V4H11V2H9V4H7ZM13 20V12H11V20H9V10H15V20H13ZM17 6V8H7V6H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Gibraltar
};
